<template>
  <div>
    <span class="cs-title">真留计划项目</span>
    <span class="cs-blue cs-accountList-viewDetail" @click="viewDetails">
      <span>查看明细</span>
      <i class="fa fa-chevron-down" v-if="!isShowDetails" aria-hidden="true"></i>
      <i class="fa fa-chevron-up" v-if="isShowDetails" aria-hidden="true"></i>
    </span>
    <el-row v-if="isShowDetails" class="grid-content">
      <el-col :span="22" :xs="24">
        <workflowServiceCard v-for="(service, index) in workflowServiceList" :key="index" :isReadonly="true" :dataIn="service" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getSAStudentWorkflowServiceList } from "@/service/studyAbroad.service";

export default {
  name: "studentSAServiceHistory",
  components: {
    workflowServiceCard: () => import("../workflowServiceCard"),
  },
  props: {
    studentId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isShowDetails: false,
      workflowServiceList: [],
    };
  },
  created() {
    this.loadSAStudentWorkflowServiceListFromServer();
  },
  methods: {
    // 从服务端获取数据相关方法
    async loadSAStudentWorkflowServiceListFromServer() {
      if (!this.studentId) {
        this.workflowServiceList = [];
        return;
      }

      try {
        let result = await getSAStudentWorkflowServiceList(this.studentId);
        if (!!result && result.success) {
          this.workflowServiceList = result.data;
        }
      } catch (error) {}
    },

    viewDetails() {
      this.isShowDetails = !this.isShowDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/history/studentSAServiceHistory.vue